import { render, staticRenderFns } from "./wxpulseresult.vue?vue&type=template&id=3079980c&scoped=true&"
import script from "./wxpulseresult.vue?vue&type=script&lang=js&"
export * from "./wxpulseresult.vue?vue&type=script&lang=js&"
import style0 from "./wxpulseresult.vue?vue&type=style&index=0&id=3079980c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3079980c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3079980c')) {
      api.createRecord('3079980c', component.options)
    } else {
      api.reload('3079980c', component.options)
    }
    module.hot.accept("./wxpulseresult.vue?vue&type=template&id=3079980c&scoped=true&", function () {
      api.rerender('3079980c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxpulseresult.vue"
export default component.exports